import { connect } from 'react-redux';
import React, { useState, useEffect } from 'react';
import { Space, Radio, Button, Form, Select } from 'antd';

const Memory = (props) => {
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [props.translationCache]);

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const formItemLayout = {
    labelCol: {
      span: 4
    },
    wrapperCol: {
      span: 14
    }
  };
  const buttonItemLayout = {
    wrapperCol: {
      span: 14,
      offset: 4
    }
  };

  return (
    <div style={{}}>
      <Form
        {...formItemLayout}
        layout="horizontal"
        name={translation('Processing')}
        className="formComponent"
      >
        <label style={{  fontWeight: 'bolder' }}>
          {translation('Processing')}
        </label>
        <Form.Item {...buttonItemLayout}>
          <Radio.Group>
            <Radio value={'Initialization'}>{translation('Initialization')}</Radio>
            <Radio value={'Error Release'}>{translation('Error Release')}</Radio>
          </Radio.Group>
        </Form.Item>
      </Form>

      <Form
        {...formItemLayout}
        layout="horizontal"
        name={translation('Target')}
        style={{ marginTop: '10px' }}
      >
        <label style={{  fontWeight: 'bolder' }}>
          {translation('Target')}
        </label>
        <Form.Item label={translation('HD')}>
          <Select style={{ width: 220 }}>
            <Select.Option value="01">01</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item {...buttonItemLayout}>
          <Radio.Group>
            <Space direction="vertical">
              <Radio value={'System Parameter'}>{translation('System Parameter')}</Radio>
              <Radio value={'Channel Release'}>{translation('Channel Parameter')}</Radio>
              <Radio value={'All Data'}>{translation('All Data')}</Radio>
            </Space>
          </Radio.Group>
        </Form.Item>
        <Form.Item {...buttonItemLayout}>
          <Button type="primary">{translation('Execute')}</Button>
        </Form.Item>
      </Form>
    </div>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(Memory);
